import { useEffect, useState } from 'react';

import {
  postPaymentLinkPayload,
  postPaymentLinkPayloadWallet,
} from '@/services/api';
import { useParams, useNavigate } from 'react-router-dom';
import { useAsyncFn } from 'react-use';

import {
  IUserPayload,
  IPostResponse,
  IPaymentResponseError,
} from '@/pages/Checkout/types/paymentLinkContextTypes';
import { sendCustomEvent } from '@useblu/blu-lytics';

const usePostPaymentLink = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [postIsLoading, setPostIsloading] = useState<boolean>(false);

  const [postResponse, postRequest] = useAsyncFn(postPaymentLinkPayload);
  const [postResponseWallet, postRequestWallet] = useAsyncFn(
    postPaymentLinkPayloadWallet,
  );
  const [postErrorData, setPostErrorData] =
    useState<IPaymentResponseError | null>(null);

  const redirectSuccess = (data: IPostResponse) => {
    const {
      success,
      success_url,
      error_message,
      antifraud_transaction,
      checkout_type,
    } = data;

    if (success && antifraud_transaction?.token && antifraud_transaction?.id) {
      navigate(`/${id}/antifraud`, {
        state: {
          token: antifraud_transaction?.token,
          transactionId: antifraud_transaction?.id,
        },
      });
      return;
    }

    if (success && !error_message && success_url) {
      sendCustomEvent('link_blu_checkout_redirect', {
        redirect_url: success_url,
      });

      window.location.replace(success_url);
    }

    if (success && checkout_type === 'wallet') {
      navigate(`/success/${id}`);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const redirectError = (error: any) => {
    setPostIsloading(false);
    setPostErrorData(error.response?.data);
  };

  const handlePostSubmit = async (payload: any) => {
    setPostIsloading(true);

    postRequest(id, payload);
  };

  const handlePostSubmitWallet = async (
    payload: any,
    type: string,
    installments: number,
  ) => {
    setPostIsloading(true);

    postRequestWallet(id, payload, type, installments);
  };

  useEffect(() => {
    if (postResponseWallet.loading) return;
    if (postResponseWallet.value?.data) {
      redirectSuccess(postResponseWallet.value?.data);
      setPostIsloading(false);
    }
    if (postResponseWallet.error) redirectError(postResponseWallet.error);
  }, [postResponseWallet]);

  useEffect(() => {
    if (postResponse.loading) return;
    if (postResponse.value?.data) {
      redirectSuccess(postResponse.value?.data);
      setPostIsloading(false);
    }
    if (postResponse.error) redirectError(postResponse.error);
  }, [postResponse]);

  return {
    postIsLoading,
    postErrorData,
    setPostErrorData,
    handlePostSubmit,
    handlePostSubmitWallet,
  };
};

export default usePostPaymentLink;
